
/* User defined models */
export class Slot {
  id: string;
  uri: string;
  startDateTime: Date;
  testDate?: any;
  testTime?: any;
  testEndTime?: any;
  duration?: any;

  constructor(
    id: string,
    uri: string,
    startDateTime: Date,
    testDate?: any,
    testTime?: any,
    testEndTime?: any,
    duration?: number
  ) {
    this.id = id;
    this.uri = uri;
    this.startDateTime = startDateTime;
    this.duration = duration;
    this.testTime = testTime;
    this.testEndTime = testEndTime;
    this.testDate = testDate;
  }
}
